






































import {Component, Vue, Watch} from 'vue-property-decorator';
import store from '@/store';
import {
  MY_COMPANY_CHANGED_LISTENER_SERVICE_INSTANCE
} from '@/views/pageskeleton/companychange/company-changed-listener.service';
import {USER_SERVICE_INSTANCE} from '@/services/user.service';

import '@/compiled-icons/lock';
import '@/compiled-icons/lock-open-outline';

@Component
export default class CompanyAndUserIndicatorTemplate extends Vue {

  user: DisguiseDto.UserDataDto = store.state.user;

  @Watch('$store.state.user') onUserUpdated(value: DisguiseDto.UserDataDto) {
    this.user = value;
  }

  created() {
    MY_COMPANY_CHANGED_LISTENER_SERVICE_INSTANCE.registerListener(() => {
      // update user details after change
      USER_SERVICE_INSTANCE.loadUserDetails().then((userInfo) => {
        // set the user info to the vuex store
        store.commit('setUserInfo', {userInfo: userInfo.data});
      });
    });
  }

}
